import { z } from 'zod';
import { CustomErrorParams, CustomErrorType, Validation } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SellLimitFieldNames } from '../../components/fieldNames';
import { allSpacesSchema, rateSchema, resourceCategorySchema } from './common';

const nullishDateIntervalSchema = z.object({
    [SellLimitFieldNames.LIMIT_START_FIELD_NAME]: Validation.DateTime.Utc.nullish(),
    [SellLimitFieldNames.LIMIT_END_FIELD_NAME]: Validation.DateTime.Utc.nullish(),
    [SellLimitFieldNames.DAYS_FIELD_NAME]: z.array(z.string()).nonempty(),
});

const refineDateFields = (
    fieldName: SellLimitFieldNames.LIMIT_START_FIELD_NAME | SellLimitFieldNames.LIMIT_END_FIELD_NAME
) =>
    [
        (data: z.infer<typeof nullishDateIntervalSchema>) => {
            const firstTimeUnitStartUtc = data[fieldName];
            const days = data[SellLimitFieldNames.DAYS_FIELD_NAME];
            return !(!firstTimeUnitStartUtc && days.length < 7);
        },
        {
            path: [fieldName] as (string | number)[],
            params: {
                errorType: CustomErrorType.Other,
                textKey: TextKey.Required,
            } satisfies CustomErrorParams,
        },
    ] as const;

export const deleteSellLimitFormSchema = z.intersection(
    nullishDateIntervalSchema
        .refine(...refineDateFields(SellLimitFieldNames.LIMIT_START_FIELD_NAME))
        .refine(...refineDateFields(SellLimitFieldNames.LIMIT_END_FIELD_NAME)),
    z.object({
        [SellLimitFieldNames.RATE_SELECT_OPTION_FIELD_NAME]: rateSchema,
        [SellLimitFieldNames.SPACE_SELECT_OPTION_FIELD_NAME]: z.discriminatedUnion('type', [
            allSpacesSchema.extend({
                [SellLimitFieldNames.CLEAR_ALL_RESOURCE_CATEGORIES]: z.boolean().optional(),
            }),
            resourceCategorySchema,
        ]),
    })
);

export type DeleteSellLimitFormModel = z.infer<typeof deleteSellLimitFormSchema>;
